import './subscribe.component.scss'
// import './subscribe.component.pug'
import { Application } from '../../helpers/app'
import axios from 'axios'
const subscribeForm = document.getElementById('subscribeForm')
function emailIsValid(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}
const formSubmitHandler = async (event) => {
  event.preventDefault()
  const emailField = event.target.querySelector('input').value
  const button = event.target.querySelector('button')
  if (emailIsValid(emailField)) {
    button.disabled = true
    try {
      const response = await axios({
        method: 'POST',
        url: '/api/newsletter-sign-up',
        data: {
          _token: Application.CSRF,
          email: emailField
        }
      })
      Application.message(response.data || 'Thank you! Message has been sent')
      try {
        /*eslint-disable no-undef*/
        ga('send', {
          hitType: 'event',
          eventCategory: 'Tell More Email',
          eventAction: 'subscribed'
        })
        /*eslint-enable no-undef*/
      } catch (e) {}
    } catch (e) {
      Application.error(e.toString())
    } finally {
      button.disabled = false
    }
  } else {
    Application.error('Please fill correct email address')
  }
}

if (subscribeForm) {
  subscribeForm.addEventListener('submit', formSubmitHandler)
} else {
  console.warn('#subscribeForm element undefined')
}
